var Qe = Object.defineProperty;
var Ze = (e, t, n) => t in e ? Qe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var ge = (e, t, n) => Ze(e, typeof t != "symbol" ? t + "" : t, n);
import { jsxs as q, jsx as v, Fragment as ie } from "react/jsx-runtime";
import { useRef as V, useState as z, useCallback as se, useEffect as Q, useMemo as ne, createContext as et, useContext as tt, useLayoutEffect as he, Fragment as fe, Component as nt, cloneElement as rt } from "react";
import { flushSync as at, createPortal as ot } from "react-dom";
const st = "ads_consent";
function it() {
  try {
    const e = localStorage.getItem(st);
    return e === "granted" || e === "denied" ? e : null;
  } catch {
    return null;
  }
}
class xe extends Error {
  constructor() {
    super(...arguments);
    ge(this, "network");
    ge(this, "status");
  }
}
const de = {
  apiBase: "",
  getToken: null,
  // Tells the server whether ad/analytics consent was granted, so server-side [S] Amplitude
  // events are emitted only for consenting users (fail-closed).
  adsConsent: () => it() === "granted" ? "granted" : "denied"
};
function ct(e) {
  Object.assign(de, e);
}
async function le(e, t, n, i) {
  const c = {
    "Content-Type": "application/json",
    "X-Ads-Consent": de.adsConsent()
  }, a = de.getToken ? await de.getToken() : "";
  a && (c.Authorization = `Bearer ${a}`);
  let s;
  try {
    s = await fetch(`${de.apiBase}/api${t}`, {
      method: e,
      headers: c,
      body: n !== void 0 ? JSON.stringify(n) : void 0,
      signal: i == null ? void 0 : i.signal
    });
  } catch (h) {
    if ((h == null ? void 0 : h.name) === "AbortError") throw h;
    const x = new xe("Could not reach the server. Please check your connection.");
    throw x.network = !0, x;
  }
  const o = await s.json().catch(() => ({}));
  if (!s.ok) {
    const h = new xe(o.error || `Request failed (${s.status})`);
    throw h.status = s.status, h;
  }
  return o;
}
const J = {
  get: (e, t) => le("GET", e, void 0, t),
  post: (e, t, n) => le("POST", e, t, n),
  patch: (e, t, n) => le("PATCH", e, t, n),
  // `del` is the historic alias many call sites use; `delete` reads naturally in newer code.
  del: (e, t) => le("DELETE", e, void 0, t),
  delete: (e, t) => le("DELETE", e, void 0, t)
}, lt = () => window.scrollTo({ top: 0, behavior: "smooth" });
function ut(e, t = {}) {
  const n = V(t);
  n.current = t;
  const i = () => (n.current.scrollTop || lt)(), [c, a] = z(null), [s, o] = z(null), [h, x] = z({}), _ = V(/* @__PURE__ */ new Set()), [M, O] = z(!0), [p, b] = z(null), [F, Y] = z(null), [B, I] = z(null), [$, C] = z(!1), [k, H] = z(null), [T, j] = z(null), [U, W] = z(!1), [G, m] = z(!1), N = se(async (r, f) => {
    try {
      const d = `targetLang=${encodeURIComponent(r)}` + (f ? `&bookId=${f}` : ""), u = await J.get(`/vocab?${d}`), g = {};
      for (const S of u.words) g[S.lemma] = S;
      x(g);
    } catch {
    }
  }, []);
  Q(() => {
    let r = !1;
    O(!0), b(null);
    async function f() {
      const d = n.current.offline;
      if (!d) return null;
      const u = await d.loadBundle(e);
      if (!u || !Array.isArray(u.pages) || !u.pages.length) return null;
      const g = u.pages[0];
      return { book: {
        id: u.bookId,
        title: u.title || "Offline book",
        target_lang: u.targetLang,
        native_lang: u.nativeLang,
        cefr_level: u.cefrLevel,
        status: "active",
        mine: !0,
        // The highest cached page, so goToPage's "atEnd" check doesn't prefetch online.
        page_count: u.pages[u.pages.length - 1].page_number,
        current_page: g.page_number,
        offline: !0
      }, currentPage: g };
    }
    return J.get(`/books/${e}`).then(async (d) => {
      r || (a(d.book), o(d.currentPage), await N(d.book.target_lang, d.book.id), d.book.status === "active" && d.book.mine && J.post(`/books/${e}/prefetch`).catch(() => {
      }));
    }).catch(async (d) => {
      if (r) return;
      const u = await f();
      u ? (a(u.book), o(u.currentPage)) : (b(d.message), Y(d.status ?? null));
    }).finally(() => !r && O(!1)), () => {
      r = !0;
    };
  }, [e, N]);
  const y = se(
    async (r, f) => {
      var S;
      const d = r.lemma;
      if (!d || !s || h[d]) return;
      const u = (s.word_list || []).find((R) => R.lemma === d), g = (u == null ? void 0 : u.translation) || "";
      x((R) => ({ ...R, [d]: { lemma: d, translation: g, status: "learning", pending: !0 } }));
      try {
        const R = await J.post(`/books/${e}/click-word`, {
          lemma: d,
          surface: r.t,
          translation: g,
          pageNumber: s.page_number,
          contextSentence: f || null
        });
        if (_.current.has(d)) {
          _.current.delete(d), (S = R == null ? void 0 : R.vocab) != null && S.id && J.del(`/vocab/${R.vocab.id}`).catch(() => {
          });
          return;
        }
        x((A) => ({ ...A, [d]: R.vocab }));
      } catch {
      }
    },
    [e, s, h]
  ), P = se(
    async (r) => {
      var d, u;
      const f = h[r];
      if (!(!f || !f.id)) {
        x((g) => ({ ...g, [r]: { ...f, status: "learned" } }));
        try {
          const g = await J.post(`/vocab/${f.id}/learned`, { bookId: e });
          x((S) => ({ ...S, [r]: g.vocab })), (u = (d = n.current).track) == null || u.call(d, "word_learned", {
            target_lang: f.target_lang || (c == null ? void 0 : c.target_lang),
            native_lang: f.native_lang || (c == null ? void 0 : c.native_lang)
          });
        } catch {
          x((g) => ({ ...g, [r]: f }));
        }
      }
    },
    [e, h, c]
  ), D = se(
    async (r) => {
      const f = h[r];
      if (!(!f || !f.id)) {
        x((d) => ({ ...d, [r]: { ...f, status: "learning" } }));
        try {
          const d = await J.post(`/vocab/${f.id}/relearn`, { bookId: e });
          x((u) => ({ ...u, [r]: d.vocab }));
        } catch {
          x((d) => ({ ...d, [r]: f }));
        }
      }
    },
    [e, h]
  ), L = se(async (r) => {
    const f = typeof r == "string" ? { userResponse: r } : r || {};
    C(!0), I(null), H(null), m(!1);
    const d = (c == null ? void 0 : c.page_count) || 0;
    try {
      const u = await J.post(`/books/${e}/next-page`, f);
      a(u.book), o(u.page), (u.levelChange === "up" || u.levelChange === "down") && (H(u.levelChange), j(u.fromLevel || null)), u.suggestAuto && m(!0), i(), u.book.status === "active" && u.book.mine && J.post(`/books/${e}/prefetch`).catch(() => {
      });
    } catch (u) {
      const g = u;
      let S = !1;
      if (g.network)
        for (let R = 0; R < 30 && !S; R++) {
          await new Promise((A) => setTimeout(A, 3e3));
          try {
            const A = await J.get(`/books/${e}`);
            if (A.book && A.book.page_count > d) {
              const X = await J.get(`/books/${e}/pages/${A.book.page_count}`);
              a({ ...A.book, mine: A.book.mine }), o(X.page), i(), A.book.status === "active" && A.book.mine && J.post(`/books/${e}/prefetch`).catch(() => {
              }), S = !0;
            }
          } catch {
          }
        }
      S || I(g.message);
    } finally {
      C(!1);
    }
  }, [e, c]), w = se(async (r) => {
    I(null), H(null);
    const f = n.current.offline;
    async function d() {
      if (!f) return !1;
      const u = await f.getOfflinePage(e, r);
      return u ? (o(u), a((g) => g && { ...g, current_page: r }), i(), !0) : !1;
    }
    if (f != null && f.isOffline()) {
      if (await d()) return;
      I("Offline — this page isn’t downloaded. Reconnect to keep reading.");
      return;
    }
    try {
      const u = await J.get(`/books/${e}/pages/${r}`);
      o(u.page), a((S) => S && { ...S, current_page: r }), J.post(`/books/${e}/current-page`, { page: r }).catch(() => {
      }), (c == null ? void 0 : c.page_count) && r >= c.page_count && J.post(`/books/${e}/prefetch`).catch(() => {
      }), i();
    } catch (u) {
      if (await d()) return;
      I(u.message);
    }
  }, [e, c == null ? void 0 : c.page_count]), E = se(
    async (r) => {
      try {
        const f = await J.post(`/books/${e}/level`, { level: r });
        a(f.book), m(!1);
      } catch (f) {
        I(f.message);
      }
    },
    [e]
  ), l = se(
    async (r) => {
      W(!0), I(null), H(null);
      try {
        const f = await J.post(`/books/${e}/rewrite-page`, { level: r });
        a(f.book), o(f.page), i();
      } catch (f) {
        I(f.message);
      } finally {
        W(!1);
      }
    },
    [e]
  );
  return {
    book: c,
    page: s,
    vocabMap: h,
    loading: M,
    error: p,
    errorStatus: F,
    actionError: B,
    generating: $,
    levelNotice: k,
    levelFrom: T,
    rewriting: U,
    clickWord: y,
    markLearned: P,
    relearn: D,
    nextPage: L,
    goToPage: w,
    setLevel: E,
    rewritePage: l,
    autoSuggest: G,
    dismissLevelNotice: () => H(null),
    dismissAutoSuggest: () => m(!1),
    // Merge a server-fresh row (e.g. after the Settings tab edits translation languages).
    applyBook: (r) => a((f) => ({ ...f || {}, ...r })),
    // Merge a fresh vocab row (e.g. after a phrase save, so it shows in the Words tab at once).
    applyVocab: (r) => {
      r != null && r.lemma && x((f) => ({ ...f, [r.lemma]: r }));
    },
    // Used when an extended selection supersedes a single-word save made a moment earlier.
    removeVocab: async (r) => {
      const f = h[r];
      if (!(f != null && f.id)) {
        _.current.add(r), x((d) => {
          if (!(r in d)) return d;
          const { [r]: u, ...g } = d;
          return g;
        });
        return;
      }
      x((d) => {
        const { [r]: u, ...g } = d;
        return g;
      });
      try {
        await J.del(`/vocab/${f.id}`);
      } catch {
        x((d) => ({ ...d, [r]: f }));
      }
    }
  };
}
const dt = 2e4;
function ft(e) {
  var Y, B, I;
  const { book: t, page: n, vocabMap: i, polyglot: c = !1 } = e, a = V(e);
  a.current = e;
  const [s, o] = z(null), [h, x] = z({}), _ = V(
    { id: null, action: null, initialStatus: null }
  ), M = () => o(null), O = () => {
    var $, C, k;
    o(null);
    try {
      ($ = window.getSelection()) == null || $.removeAllRanges();
    } catch {
    }
    (k = (C = a.current).onDismiss) == null || k.call(C);
  }, p = n == null ? void 0 : n.page_number;
  Q(() => {
    o(null), x({});
  }, [p]), Q(() => {
    if (!s) return;
    function $(C) {
      const k = C.target;
      k instanceof Element && (k.closest(".word-popup, .sel-handle, .word, .tr-word") || O());
    }
    return document.addEventListener("mousedown", $), () => document.removeEventListener("mousedown", $);
  }, [s]), Q(() => {
    var j, U;
    if (c || !s || !t) return;
    const $ = (j = s.token) == null ? void 0 : j.t;
    if (!((U = s.token) != null && U.lemma) || !$ || s.inContextTranslation) return;
    let C = !1;
    const k = s.id, H = (W) => o((G) => G && G.id === k ? { ...G, ...W } : G), T = async (W) => {
      try {
        const G = await J.post("/translate", {
          surface: $,
          targetLang: t.target_lang,
          nativeLang: t.native_lang,
          context: s.sentence || void 0
        });
        if (C) return;
        if (G != null && G.translation) {
          H({ inContextTranslation: G.translation, fallbackBusy: !1 });
          return;
        }
      } catch {
      }
      C || (W < 2 ? setTimeout(() => {
        C || T(W + 1);
      }, 600 + W * 400) : H({ fallbackBusy: !1 }));
    };
    return H({ fallbackBusy: !0 }), T(0), () => {
      C = !0;
    };
  }, [s == null ? void 0 : s.id, c]);
  function b($, C, k, H) {
    var P, D, L;
    const T = a.current;
    if (!t || !$.lemma || (P = T.shouldIgnoreClick) != null && P.call(T) || s && ((D = s.token) == null ? void 0 : D.lemma) === $.lemma) return;
    if ((s || T.hasOtherPopup) && at(() => {
      var w, E, l;
      o(null), (w = T.onCloseOthers) == null || w.call(T);
      try {
        (E = window.getSelection()) == null || E.removeAllRanges();
      } catch {
      }
      (l = T.onDismiss) == null || l.call(T);
    }), k)
      try {
        const w = document.createRange();
        w.selectNodeContents(k);
        const E = window.getSelection();
        E == null || E.removeAllRanges(), E == null || E.addRange(w);
      } catch {
      }
    if (String(t.target_lang || "").trim().toLowerCase() === String(t.native_lang || "").trim().toLowerCase()) {
      o({
        id: Date.now(),
        token: $,
        rect: C,
        wasTracked: !1,
        initialStatus: null,
        action: "definitionOnly",
        spanEl: k,
        sentence: H || "",
        definitionOnly: !0
      });
      return;
    }
    const U = $.lemma, W = i[U] || null, G = !!W, m = (W == null ? void 0 : W.status) || (G ? "learning" : null);
    let N;
    G ? m === "learned" ? N = "learnedRelearn" : N = "markLearned" : N = "fresh", o({ id: Date.now(), token: $, rect: C, wasTracked: G, initialStatus: m, action: N, spanEl: k, sentence: H || "" }), T.clickWord($, H), (L = T.onOpened) == null || L.call(T, N, U);
    const y = T.polyglot ? T.polyglotLangs || [] : [];
    if (y.length) {
      const w = $.t;
      x((l) => ({ ...l, [U]: { busy: !0, translations: {} } }));
      const E = (l) => Promise.race([
        l,
        new Promise((r) => setTimeout(() => r(null), dt))
      ]);
      Promise.all(
        y.map(
          (l) => E(J.post("/translate", { surface: w, targetLang: t.target_lang, nativeLang: l }).then((r) => ({ lang: l, text: r.translation || "" })).catch(() => null))
        )
      ).then((l) => {
        const r = {};
        for (const f of l)
          f && (r[f.lang] = f.text);
        x((f) => ({ ...f, [U]: { busy: !1, translations: r } }));
      });
    }
  }
  if (s != null && s.id && _.current.id !== s.id) {
    const $ = s.action || null, C = s.initialStatus || ($ === "learnedRelearn" ? "learned" : $ === "markLearned" ? "learning" : null);
    _.current = { id: s.id, action: $, initialStatus: C };
  } else !s && _.current.id !== null && (_.current = { id: null, action: null, initialStatus: null });
  let F = null;
  if (s && n) {
    const $ = s.token.lemma || "", C = i[$] || null, k = h[$] || null;
    let H;
    if (c && (k != null && k.translations) && Object.keys(k.translations).length)
      H = Object.entries(k.translations).map(([j, U]) => `${j}: ${U}`).join(`
`);
    else {
      const j = String(s.token.t || "").toLowerCase(), U = j ? Object.values(i).find((W) => String((W == null ? void 0 : W.surface_seen) || "").toLowerCase() === j) : null;
      H = s.inContextTranslation || (C == null ? void 0 : C.translation) || (U == null ? void 0 : U.translation) || ((Y = (n.word_list || []).find((W) => W.lemma === $)) == null ? void 0 : Y.translation) || ((B = (n.word_list || []).find((W) => String(W.surface || "").toLowerCase() === j)) == null ? void 0 : B.translation) || "";
    }
    const T = Object.keys((k == null ? void 0 : k.translations) || {})[0];
    F = {
      lemma: $,
      translation: H,
      busy: !!(C != null && C.pending || s.fallbackBusy || c && (k != null && k.busy) && !((I = k == null ? void 0 : k.translations) != null && I[T])),
      action: _.current.action,
      initialStatus: _.current.initialStatus,
      canMarkLearned: _.current.action === "markLearned"
    };
  }
  return { popup: s, view: F, onWordClick: b, closePopup: M, dismiss: O };
}
const gt = 1e3, ht = 120, Te = (e) => e.split(/\s+/).filter(Boolean).length;
function _e(e) {
  const t = e.getBoundingClientRect();
  if (!t.width && !t.height) return null;
  const n = Array.from(e.getClientRects()).filter((i) => i.width || i.height);
  return { rect: t, startRect: n[0] || t, endRect: n[n.length - 1] || t };
}
function we() {
  var e;
  try {
    (e = window.getSelection()) == null || e.removeAllRanges();
  } catch {
  }
}
function pt(e) {
  const { book: t, page: n, vocabMap: i } = e, c = V(e);
  c.current = e;
  const [a, s] = z(null), [o, h] = z(null), x = V(o);
  x.current = o;
  const _ = V(null), M = V(!1), O = V(!1), p = V(null), b = V(null), F = ne(() => {
    const m = [];
    for (const N of Object.values(i)) {
      if ((N == null ? void 0 : N.status) !== "learning") continue;
      const y = String((N == null ? void 0 : N.surface_seen) || (N == null ? void 0 : N.lemma) || "");
      y.includes(" ") && m.push({ surface: y, translation: String((N == null ? void 0 : N.translation) || ""), lemma: N.lemma, id: N.id, status: N.status });
    }
    return m;
  }, [i]);
  function Y() {
    _.current && (clearTimeout(_.current), _.current = null);
  }
  function B() {
    Y(), _.current = setTimeout(() => {
      var y, P, D;
      if (_.current = null, O.current) return;
      const m = (y = window.getSelection) == null ? void 0 : y.call(window);
      if (!m || m.isCollapsed || !m.rangeCount) return;
      const N = m.toString().trim();
      if (!(N.length < 2 || Te(N) < 2)) {
        if (typeof navigator < "u" && navigator.onLine === !1) {
          (D = (P = c.current).onOffline) == null || D.call(P);
          return;
        }
        p.current !== N && U.current(N, m.getRangeAt(0).getBoundingClientRect());
      }
    }, gt);
  }
  Q(() => {
    function m(y) {
      var P;
      for (let D = y; D; D = D.parentNode)
        if (D.nodeType === 1 && ((P = D.classList) != null && P.contains("page-sheet"))) return !0;
      return !1;
    }
    function N() {
      var L;
      const y = (L = window.getSelection) == null ? void 0 : L.call(window), P = y && !y.isCollapsed && y.rangeCount ? y.toString().trim() : "";
      if (!y || !P) {
        Y(), s(null);
        return;
      }
      if (!m(y.anchorNode) || !m(y.focusNode)) {
        Y(), s(null);
        return;
      }
      const D = _e(y.getRangeAt(0));
      if (!D) {
        s(null);
        return;
      }
      s({ text: P, ...D }), Te(P) >= 2 ? B() : Y();
    }
    return document.addEventListener("selectionchange", N), () => {
      document.removeEventListener("selectionchange", N), Y();
    };
  }, [t == null ? void 0 : t.id]);
  const I = a !== null;
  Q(() => {
    if (!I) return;
    let m = 0;
    function N() {
      var L;
      const P = (L = window.getSelection) == null ? void 0 : L.call(window), D = P && !P.isCollapsed && P.rangeCount ? _e(P.getRangeAt(0)) : null;
      if (!D) {
        s(null);
        return;
      }
      s((w) => w && { ...w, ...D });
    }
    function y() {
      m && cancelAnimationFrame(m), m = requestAnimationFrame(N);
    }
    return window.addEventListener("scroll", y, { passive: !0, capture: !0 }), window.addEventListener("resize", y), () => {
      m && cancelAnimationFrame(m), window.removeEventListener("scroll", y, { capture: !0 }), window.removeEventListener("resize", y);
    };
  }, [I]);
  const $ = n == null ? void 0 : n.page_number;
  Q(() => {
    s(null), h(null), p.current = null, Y(), we();
  }, [$]);
  function C() {
    h(null);
  }
  function k() {
    h(null), s(null), we(), p.current = null, c.current.stopSpeaking();
  }
  Q(() => {
    if (!o) return;
    function m(N) {
      const y = N.target;
      y instanceof Element && (y.closest(".word-popup, .sel-handle, .word, .tr-word") || k());
    }
    return document.addEventListener("mousedown", m), () => document.removeEventListener("mousedown", m);
  }, [o]), Q(() => {
    if (!o || !t || o.translation || o.definitionOnly || o.busy || o.fallbackAttempted) return;
    let m = !1;
    const N = o.id, y = async (P) => {
      try {
        const D = await J.post("/translate", {
          surface: o.text,
          targetLang: o.sourceLang || t.target_lang,
          nativeLang: o.nativeLang || t.native_lang,
          context: o.contextSentence || void 0
        });
        if (m) return;
        if (D != null && D.translation) {
          h((L) => L && L.id === N ? { ...L, translation: D.translation, fallbackAttempted: !0 } : L);
          return;
        }
      } catch {
      }
      m || (P < 2 ? setTimeout(() => {
        m || y(P + 1);
      }, 600 + P * 400) : h((D) => D && D.id === N ? { ...D, fallbackAttempted: !0 } : D));
    };
    return y(0), () => {
      m = !0;
    };
  }, [o == null ? void 0 : o.id, o == null ? void 0 : o.translation, o == null ? void 0 : o.busy]);
  function H(m, N) {
    var P, D;
    if (M.current || !m || !t) return;
    const y = x.current;
    y && y.saved && y.lemma === m.lemma || (c.current.closeWordPopup(), (D = (P = c.current).onCloseOthers) == null || D.call(P), p.current = m.surface, h({
      id: Date.now(),
      text: m.surface,
      rect: N,
      busy: !1,
      translation: m.translation || "",
      lang: t.target_lang,
      sourceLang: t.target_lang,
      nativeLang: t.native_lang,
      saved: !0,
      saving: !1,
      lemma: m.lemma,
      vocabId: m.id,
      status: m.status || "learning"
    }));
  }
  function T(m, N) {
    var L;
    const y = c.current.translationLangFor;
    let P = N.target_lang, D = "";
    try {
      const w = (L = window.getSelection) == null ? void 0 : L.call(window);
      if (!w || !w.rangeCount) return { sourceLang: P, contextSentence: D };
      const E = w.getRangeAt(0);
      for (let d = E.commonAncestorContainer; d && d !== document.body; d = d.parentNode) {
        const u = d.nodeType === 1 ? d.classList : null;
        if (u) {
          if (u.contains("scene-translation-2")) {
            P = (y == null ? void 0 : y("second")) || (y == null ? void 0 : y("primary")) || N.native_lang;
            break;
          }
          if (u.contains("scene-translation-3")) {
            P = (y == null ? void 0 : y("third")) || (y == null ? void 0 : y("primary")) || N.native_lang;
            break;
          }
          if (u.contains("scene-translation") || u.contains("inline-sent-tr")) {
            P = (y == null ? void 0 : y("primary")) || N.native_lang;
            break;
          }
        }
      }
      let l = E.commonAncestorContainer.nodeType === 1 ? E.commonAncestorContainer : E.commonAncestorContainer.parentElement;
      const r = ["page-text", "scene-translation", "scene-translation-2", "scene-translation-3", "inline-sent-tr"];
      for (; l && l !== document.body && !r.some((d) => {
        var u;
        return (u = l.classList) == null ? void 0 : u.contains(d);
      }); )
        l = l.parentElement;
      const f = ((l == null ? void 0 : l.textContent) || "").match(/[^.!?…。！？\n]+[.!?…。！？]?/g);
      f && (D = (f.find((d) => d.includes(m.trim())) || "").trim());
    } catch {
    }
    return { sourceLang: P, contextSentence: D };
  }
  async function j(m, N) {
    const y = c.current.book;
    if (!m || !y) return;
    const { sourceLang: P, contextSentence: D } = T(m, y), L = y.native_lang;
    p.current = m, c.current.closeWordPopup();
    const w = m.toLowerCase().trim(), E = Object.values(c.current.vocabMap).find((f) => !f || f.status === "learned" ? !1 : String(f.surface_seen || "").toLowerCase().trim() === w || String(f.lemma || "").toLowerCase().trim() === w);
    if (E) {
      h({
        id: Date.now(),
        text: m,
        rect: N,
        busy: !1,
        translation: E.translation || "",
        lang: P,
        sourceLang: P,
        nativeLang: L,
        saved: !0,
        saving: !1,
        lemma: E.lemma,
        vocabId: E.id,
        status: E.status || "learning"
      }), b.current = null;
      return;
    }
    const l = { id: Date.now(), text: m, rect: N, busy: !0, translation: "", lang: P, sourceLang: P, nativeLang: L, saved: !1, saving: !1, contextSentence: D }, r = (f) => h((d) => d && d.text === m ? { ...d, busy: !1, ...f !== null ? { translation: f } : {} } : d);
    if (String(P || "").trim().toLowerCase() === String(L || "").trim().toLowerCase()) {
      h({ ...l, definitionOnly: !0 });
      try {
        const f = await J.post("/explain-phrase", { surface: m, context: D, lang: P });
        r(f.explanation || ""), b.current = null;
      } catch {
        r(null);
      }
      return;
    }
    h(l);
    try {
      const f = await J.post("/translate", {
        surface: m,
        targetLang: P,
        nativeLang: L,
        context: D || void 0
      });
      r(f.translation || ""), b.current = null;
    } catch {
      r(null);
    }
  }
  const U = V(j);
  U.current = j;
  async function W() {
    var L;
    const m = x.current, { book: N, page: y, applyVocab: P, removeVocab: D } = c.current;
    if (!(!m || !N || m.saving || m.saved) && !(!m.text || m.text.length > ht)) {
      h((w) => w && w.id === m.id ? { ...w, saving: !0 } : w);
      try {
        const w = await J.post("/click-foreign-word", {
          surface: m.text,
          sourceLang: m.sourceLang || N.target_lang,
          nativeLang: m.nativeLang || N.native_lang,
          bookId: N.id,
          pageNumber: (y == null ? void 0 : y.page_number) || null,
          contextSentence: m.contextSentence || null
        });
        w != null && w.vocab && (P == null || P(w.vocab));
        const E = b.current, l = ((L = w == null ? void 0 : w.vocab) == null ? void 0 : L.lemma) || (w == null ? void 0 : w.lemma) || null;
        if (E && D && l !== E)
          try {
            await D(E);
          } catch {
          }
        b.current = null, h(null), s(null), p.current = null, we();
      } catch {
        h((w) => w && w.id === m.id ? { ...w, saving: !1 } : w);
      }
    }
  }
  function G(m, N) {
    var d;
    N.preventDefault(), N.stopPropagation();
    const y = (d = window.getSelection) == null ? void 0 : d.call(window);
    if (!y || !y.rangeCount) return;
    const P = y.getRangeAt(0).cloneRange(), D = m === "end" ? P.startContainer : P.endContainer, L = m === "end" ? P.startOffset : P.endOffset;
    function w(u, g) {
      const S = document;
      if (S.caretRangeFromPoint) return S.caretRangeFromPoint(u, g);
      if (S.caretPositionFromPoint) {
        const R = S.caretPositionFromPoint(u, g);
        if (!R) return null;
        const A = document.createRange();
        return A.setStart(R.offsetNode, R.offset), A.setEnd(R.offsetNode, R.offset), A;
      }
      return null;
    }
    function E(u) {
      for (let g = u; g && g !== document.body; g = g.parentNode) {
        const S = g.nodeType === 1 ? g.classList : null;
        if (S && (S.contains("word") || S.contains("tr-word"))) return g;
      }
      return null;
    }
    function l(u, g) {
      const S = document.elementsFromPoint ? document.elementsFromPoint(u, g) : [document.elementFromPoint(u, g)];
      for (const R of S) {
        const A = R && E(R);
        if (A) return A;
      }
      return null;
    }
    function r(u) {
      var te;
      u.preventDefault();
      const g = u.clientX, S = u.clientY, R = S - 18;
      let A, X;
      const ee = l(g, R) || l(g, S);
      if (ee) {
        const K = document.createRange();
        K.selectNodeContents(ee), A = m === "end" ? K.endContainer : K.startContainer, X = m === "end" ? K.endOffset : K.startOffset;
      } else {
        const K = w(g, R) || w(g, S);
        if (!K) return;
        A = K.startContainer, X = K.startOffset;
      }
      let Z = A;
      for (; Z && (Z.nodeType !== 1 || !((te = Z.classList) != null && te.contains("page-sheet"))); ) Z = Z.parentNode;
      if (Z)
        try {
          const K = document.createRange();
          K.setStart(D, L), K.setEnd(D, L);
          const ce = K.comparePoint(A, X);
          if (ce === 0) return;
          const re = document.createRange();
          ce < 0 ? (re.setStart(A, X), re.setEnd(D, L)) : (re.setStart(D, L), re.setEnd(A, X));
          const ae = window.getSelection();
          ae == null || ae.removeAllRanges(), ae == null || ae.addRange(re);
        } catch {
        }
    }
    function f(u) {
      u.preventDefault(), window.removeEventListener("pointermove", r), window.removeEventListener("pointerup", f), window.removeEventListener("pointercancel", f), M.current = !0, setTimeout(() => {
        M.current = !1;
      }, 350);
    }
    window.addEventListener("pointermove", r, { passive: !1 }), window.addEventListener("pointerup", f, { passive: !1 }), window.addEventListener("pointercancel", f, { passive: !1 });
  }
  return {
    selAction: a,
    selPopup: o,
    savedPhrases: F,
    onPhraseClick: H,
    justDragged: () => M.current,
    setOriginLemma: (m) => {
      b.current = m;
    },
    clearSelection: () => {
      s(null), p.current = null;
    },
    closePhrasePopup: C,
    dismissPhrase: k,
    saveSelectedPhrase: W,
    startHandleDrag: G,
    onHandleEnter: () => {
      O.current = !0, Y();
    },
    onHandleLeave: () => {
      O.current = !1, B();
    }
  };
}
function mt(e, t) {
  const [n, i] = z(null), c = V(null), a = V(null), s = V(/* @__PURE__ */ new Map());
  Q(() => {
    s.current = /* @__PURE__ */ new Map();
  }, [t]);
  function o() {
    if (c.current) {
      try {
        c.current.abort();
      } catch {
      }
      c.current = null;
    }
    if (a.current) {
      try {
        a.current.pause();
      } catch {
      }
      a.current = null;
    }
  }
  Q(() => o, []);
  function h() {
    o(), i(null);
  }
  function x(_, M) {
    if (!e) return;
    o(), i(_);
    const O = () => i((I) => I === _ ? null : I), p = (I) => {
      const $ = new Audio(I);
      a.current = $, $.addEventListener("ended", O), $.addEventListener("error", O), $.play().catch(O);
    }, b = `${M || ""}|${_}`, F = s.current.get(b);
    if (F) {
      p(F);
      return;
    }
    const Y = new AbortController();
    c.current = Y;
    const B = M ? { text: _, language: M } : { text: _ };
    J.post(`/books/${e}/speak`, B, { signal: Y.signal }).then((I) => {
      if (!(I != null && I.audio) || Y.signal.aborted) {
        O();
        return;
      }
      s.current.set(b, I.audio), p(I.audio);
    }).catch((I) => {
      (I == null ? void 0 : I.name) !== "AbortError" && O();
    });
  }
  return { speakingSentence: n, speakWord: x, stopSpeaking: h };
}
const wt = 60, vt = 1.5;
function yt(e) {
  const { book: t, page: n, goToPage: i, nextPage: c, beforeTurn: a, interceptNext: s } = e, o = V({ x: 0, y: 0 });
  function h(p) {
    const b = {};
    p && (b.steer = p), c(b);
  }
  function x() {
    !t || !n || (n.page_number < t.page_count ? i(n.page_number + 1) : h());
  }
  function _() {
    !n || n.page_number <= 1 || (a == null || a(), i(n.page_number - 1));
  }
  function M() {
    if (!t || !n) return;
    a == null || a();
    const p = n.page_number >= t.page_count;
    p && (!t.mine || t.status === "completed") || p && t.practice || s != null && s() || x();
  }
  return { onPrev: _, onNext: M, proceedNext: x, genNextPage: h, swipeHandlers: {
    onTouchStart(p) {
      const b = p.changedTouches[0];
      o.current = { x: b.clientX, y: b.clientY };
    },
    onTouchEnd(p) {
      const b = p.changedTouches[0], F = b.clientX - o.current.x, Y = b.clientY - o.current.y;
      Math.abs(F) > wt && Math.abs(F) > Math.abs(Y) * vt && (F < 0 ? M() : _());
    }
  } };
}
const ve = "eb:audioOnClick", Pe = "eb:chunkedOn";
function ye(e) {
  try {
    return localStorage.getItem(e);
  } catch {
    return null;
  }
}
function Ae(e, t) {
  try {
    localStorage.setItem(e, t ? "1" : "0");
  } catch {
  }
}
function bt() {
  const e = V(ye(ve) !== null), [t, n] = z(() => ye(ve) !== "0"), [i, c] = z(() => ye(Pe) === "1");
  Q(() => Ae(ve, t), [t]), Q(() => Ae(Pe, i), [i]);
  function a(o) {
    e.current = !0, n(o), J.post("/settings/audio-click", { enabled: !!o }).catch(() => {
    });
  }
  function s(o) {
    e.current || n(o);
  }
  return { audioOnClick: t, setAudioOnClick: a, chunkedOn: i, setChunkedOn: c, seedAudioOnClick: s };
}
const kt = 4, St = 3, Ct = 500;
let be = 0;
const Ee = [], ke = /* @__PURE__ */ new Map(), ue = /* @__PURE__ */ new Map();
async function Lt(e) {
  var t;
  be >= kt && await new Promise((n) => Ee.push(n)), be++;
  try {
    return await e();
  } finally {
    be--, (t = Ee.shift()) == null || t();
  }
}
const Rt = (e) => new Promise((t) => setTimeout(t, e));
async function Nt(e, t, n) {
  for (let i = 0; i < St; i++) {
    i && await Rt(600 * i);
    try {
      const c = await Lt(() => J.post("/exp/chunked-translate", { text: e, sourceLang: t, targetLang: n }));
      if (Array.isArray(c.pairs))
        return { text: e, pairs: c.pairs, words: Array.isArray(c.words) ? c.words : [] };
    } catch {
    }
  }
  return { text: e, pairs: null, words: [] };
}
function qe(e, t, n) {
  const i = `${t}\0${n}\0${e}`, c = ue.get(i);
  if (c) return Promise.resolve(c);
  const a = ke.get(i);
  if (a) return a;
  const s = Nt(e, t, n).then((o) => (ke.delete(i), o.pairs && (ue.size >= Ct && ue.delete(ue.keys().next().value), ue.set(i, o)), o));
  return ke.set(i, s), s;
}
const xt = /[.!?…。！？]/;
function Me(e, t) {
  const n = [];
  let i = [];
  for (const c of e || []) {
    i.push(c);
    const a = c.t || "";
    !c.w && (xt.test(a) || t && a.includes(`
`)) && (n.push(i), i = []);
  }
  return i.length && n.push(i), n;
}
class oe {
  // Legacy pages have no scenes: the whole page is one.
  static scenes(t) {
    var n;
    return (n = t.scenes) != null && n.length ? t.scenes : [{ text: t.plain_text, tokens: t.tokens || [] }];
  }
  static text(t) {
    return (t || []).map((n) => n.t).join("").trim();
  }
  // The chunked view's sentences (a line break ends one too); their texts key the chunked prefetch.
  static sentences(t) {
    return Me(t, !0).filter((n) => oe.text(n).length > 0);
  }
  // Punctuation only: the inline translation layout needs the same count as splitTranslationSentences.
  static punctuationSentences(t) {
    return Me(t, !1);
  }
}
function Tt(e, t, n) {
  const [i, c] = z({ pageNumber: 0, byText: /* @__PURE__ */ new Map(), status: "idle" }), a = V(i), s = (o) => {
    a.current = o, c(o);
  };
  return Q(() => {
    if (!e || !t) return;
    const o = t.page_number, h = n ? [...new Set(oe.scenes(t).flatMap((_) => oe.sentences(_.tokens).map(oe.text)))] : [];
    if (!h.length) {
      s({ pageNumber: o, byText: /* @__PURE__ */ new Map(), status: "ready" });
      return;
    }
    let x = !1;
    return s({ pageNumber: o, byText: /* @__PURE__ */ new Map(), status: "loading" }), Promise.all(h.map((_) => qe(_, e.target_lang, e.native_lang))).then((_) => {
      if (x) return;
      const M = new Map(_.map((O) => [O.text, { pairs: O.pairs, words: O.words }]));
      s({ pageNumber: o, byText: M, status: "ready" });
    }), () => {
      x = !0;
    };
  }, [t == null ? void 0 : t.page_number, n, e == null ? void 0 : e.id]), {
    prefetched: t && i.pageNumber === t.page_number && i.status === "ready" ? i.byText : null,
    isReadyFor: (o) => a.current.pageNumber === o && a.current.status === "ready"
  };
}
const _t = 500, Pt = 7e3, At = 200, Et = 6;
function Mt(e, t) {
  const n = Object.values(e || {}).filter((a) => a.status === "learning" && a.translation && (a.surface_seen || a.lemma)).map((a) => ({ word: a.surface_seen || a.lemma, meaning: a.translation }));
  if (n.length >= Et) return n;
  const i = new Set(n.map((a) => a.word.toLowerCase())), c = ((t == null ? void 0 : t.word_list) || []).filter((a) => a && a.translation && (a.surface || a.lemma)).map((a) => ({ word: a.surface || a.lemma, meaning: a.translation })).filter((a) => !i.has(a.word.toLowerCase()) && i.add(a.word.toLowerCase()));
  return [...n, ...c];
}
function Ot({ generating: e, actionError: t, vocabMap: n, page: i, isChunkedReady: c }) {
  const [a, s] = z(!1), [o, h] = z(!1), [x, _] = z(null), M = ne(() => Mt(n, i), [n, i]), O = M.length >= 2, p = V(i);
  p.current = i;
  const b = V(c);
  b.current = c;
  const F = V(!1), Y = V(0), B = V(void 0), I = V(void 0), $ = () => {
    window.clearTimeout(B.current), window.clearTimeout(I.current);
  };
  return Q(() => $, []), Q(() => {
    if (e && !F.current)
      $(), h(!1), O && (B.current = window.setTimeout(() => {
        s(!0), _(M), Y.current = Date.now();
      }, _t));
    else if (!e && F.current && (window.clearTimeout(B.current), a))
      if (t)
        s(!1), h(!1), _(null);
      else {
        const C = () => {
          var H;
          const k = (H = p.current) == null ? void 0 : H.page_number;
          if (k !== void 0 && !b.current(k)) {
            I.current = window.setTimeout(C, At);
            return;
          }
          h(!0);
        };
        I.current = window.setTimeout(C, Math.max(0, Pt - (Date.now() - Y.current)));
      }
    F.current = e;
  }, [e, O, a, t]), {
    loadingGame: a,
    genDone: o,
    gameSnapshot: x,
    busy: e || a,
    proceed: () => {
      $(), s(!1), h(!1), _(null);
    },
    freeze: () => _(M),
    clearSnapshot: () => _(null)
  };
}
function Ge(e, t, n = Date.now(), i = 3e4) {
  const c = [...new Set(
    (Array.isArray(t) ? t : []).filter(Number.isInteger)
  )];
  if (!c.length)
    return { sentenceIndex: -1, state: e };
  const a = c.join(","), s = (e == null ? void 0 : e.lineKey) === a && Number.isFinite(e == null ? void 0 : e.clickedAt) && n - e.clickedAt < i, o = Number.isInteger(e == null ? void 0 : e.slot) ? e.slot : -1, h = s ? (o + 1) % c.length : 0;
  return {
    sentenceIndex: c[h],
    state: { lineKey: a, slot: h, clickedAt: n }
  };
}
const Ue = et({}), Ce = () => tt(Ue);
function $t(e) {
  const t = [];
  let n = [];
  for (const i of e) {
    n.push(i);
    const c = i.t || "";
    !i.w && (/[.!?…]/.test(c) || c.includes(`
`)) && (t.push(n), n = []);
  }
  return n.length && t.push(n), t;
}
function Ve(e, t, n, i) {
  if (!t || !t.w) return !1;
  if (i && i.has(e)) return !0;
  const c = n && n[t.lemma];
  return (c == null ? void 0 : c.status) === "learning";
}
function Oe(e, t, n, i) {
  return t >= 0 && t < e.length && Ve(t, e[t], n, i);
}
function $e(e) {
  return String(e || "").toLowerCase().replace(/^[^\p{L}\p{N}]+|[^\p{L}\p{N}]+$/gu, "");
}
function De(e) {
  return e.includes(`
`) ? e.split(`
`).map((t, n) => /* @__PURE__ */ q(fe, { children: [
    n > 0 && /* @__PURE__ */ v("br", {}),
    t
  ] }, n)) : e;
}
function Dt({
  tokens: e,
  vocabMap: t,
  savedPhrases: n,
  onWordClick: i,
  onPhraseClick: c,
  onPlaySentence: a,
  onTranslateSentence: s,
  sentenceTranslations: o,
  speakingSentence: h,
  audioOnClick: x,
  showTranslateIcon: _,
  dialogue: M
}) {
  const O = Ce(), p = V(null), [b, F] = z([]), [Y, B] = z(-1), I = $t(e || []), $ = I.map((l) => l.map((r) => r.t).join("").trim()), C = [], k = [], H = [];
  I.forEach((l, r) => {
    const f = C.length, d = l.findIndex((u) => (u == null ? void 0 : u.w) || /\S/u.test((u == null ? void 0 : u.t) || ""));
    k.push(f + (d >= 0 ? d : 0)), l.forEach((u) => {
      H.push(r), C.push(u);
    });
  });
  const T = (l) => $[H[l]] || "", j = C.map((l) => l.t).join(""), U = /* @__PURE__ */ new Set();
  if (M) {
    let l = [], r = 0, f = !1, d = !0;
    const u = () => {
      l.forEach((S) => U.add(S)), l = [], r = 0, d = !1;
    }, g = () => {
      l = [], r = 0, f = !1, d = !0;
    };
    for (let S = 0; S < C.length; S++) {
      const R = C[S], A = R.t || "";
      if (!R.w && /^\s+$/.test(A)) {
        A.includes(`
`) && g();
        continue;
      }
      if (!(!d || f)) {
        if (!R.w && /[.!?…]/.test(A)) {
          f = !0;
          continue;
        }
        if (R.w && r >= 5) {
          f = !0;
          continue;
        }
        l.push(S), R.w && (r += 1), !R.w && A.includes(":") && u();
      }
    }
  }
  const W = /* @__PURE__ */ new Set(), G = /* @__PURE__ */ new Map(), m = /* @__PURE__ */ new Map(), N = /* @__PURE__ */ new Set();
  if (n && n.length) {
    const l = [];
    C.forEach((r, f) => {
      r.w && l.push({ flatIdx: f, bare: $e(r.t) });
    });
    for (const r of n) {
      const f = typeof r == "string" ? r : r.surface, d = typeof r == "string" ? "" : r.translation || "", u = String(f || "").toLowerCase().split(/\s+/).map((g) => $e(g)).filter(Boolean);
      if (!(u.length < 2))
        for (let g = 0; g + u.length <= l.length; g++) {
          let S = !0;
          for (let R = 0; R < u.length; R++)
            if (l[g + R].bare !== u[R]) {
              S = !1;
              break;
            }
          if (S) {
            N.add(l[g].flatIdx);
            for (let R = 0; R < u.length; R++) {
              const A = l[g + R].flatIdx;
              W.add(A), d && !G.has(A) && G.set(A, d), typeof r == "object" && !m.has(A) && m.set(A, r);
            }
          }
        }
    }
  }
  he(() => {
    let l = !1;
    function r() {
      const d = p.current;
      if (!d || l) return;
      const u = d.getBoundingClientRect().top, g = [];
      try {
        const R = document.createRange();
        R.selectNodeContents(d);
        for (const A of R.getClientRects()) {
          if (A.width < 1 || A.height < 1) continue;
          const X = A.top - u, ee = g[g.length - 1];
          ee && Math.abs(X - ee.top) <= 4 ? ee.height = Math.max(ee.height, A.height) : g.push({ top: X, height: A.height });
        }
      } catch {
      }
      if (!g.length) {
        l || F([]);
        return;
      }
      const S = g.map((R) => ({ top: R.top, height: R.height, starters: [] }));
      I.forEach((R, A) => {
        const X = d.children[k[A]];
        if (!X) return;
        const Z = X.getBoundingClientRect().top - u;
        let te = 0;
        for (let K = 0; K < g.length; K++)
          Z >= g[K].top - 6 && (te = K);
        S[te].starters.push(A);
      }), l || F(S);
    }
    r();
    const f = new ResizeObserver(r);
    return p.current && f.observe(p.current), document.fonts && document.fonts.ready && document.fonts.ready.then(() => {
      l || r();
    }), () => {
      l = !0, f.disconnect();
    };
  }, [j]);
  const y = h ? $.findIndex((l) => l === h) : -1;
  function P(l) {
    const r = p.current;
    if (!r) return -1;
    const f = l - r.getBoundingClientRect().top;
    for (let d = 0; d < b.length; d += 1) {
      const u = b[d];
      if (f >= u.top - 3 && f <= u.top + u.height + 3)
        return u.starters.length ? d : -1;
    }
    return -1;
  }
  function D(l) {
    a && B(P(l.clientY));
  }
  function L(l) {
    var R;
    if (!a) return;
    let r = l.target;
    for (; r && r !== p.current; ) {
      if (((R = r == null ? void 0 : r.dataset) == null ? void 0 : R.fi) != null) return;
      const A = r == null ? void 0 : r.classList;
      if (A && (A.contains("line-speak") || A.contains("line-translation"))) return;
      r = r.parentNode;
    }
    const f = p.current;
    if (!f) return;
    const d = f.getBoundingClientRect();
    if (l.clientX >= d.left || l.clientY < d.top || l.clientY > d.bottom) return;
    const u = P(l.clientY);
    if (u < 0) return;
    const g = b[u], S = {
      left: d.left,
      top: d.top + g.top,
      right: d.left + 1,
      bottom: d.top + g.top + g.height,
      width: 1,
      height: g.height,
      x: d.left,
      y: d.top + g.top
    };
    E(u, S);
  }
  const w = V(null);
  Q(() => {
    w.current = null;
  }, [j]);
  function E(l, r) {
    const f = b[l];
    if (!f || !a) return;
    const d = Ge(w.current, f.starters);
    if (d.sentenceIndex < 0) return;
    w.current = d.state;
    const u = $[d.sentenceIndex];
    !u || !a || a(u, r);
  }
  return /* @__PURE__ */ q(
    "div",
    {
      className: "page-text-wrap",
      onMouseMove: D,
      onMouseLeave: () => B(-1),
      onClick: L,
      children: [
        a && b.map((l, r) => {
          if (!l.starters.length) return null;
          const f = Y === r, d = l.starters.includes(y);
          if (!f && !d) return null;
          const u = l.top + l.height / 2;
          return /* @__PURE__ */ v(
            "button",
            {
              type: "button",
              className: "line-speak" + (d ? " line-speak-loading" : ""),
              style: { top: `${u}px` },
              onClick: (g) => E(r, g.currentTarget.getBoundingClientRect()),
              "aria-label": "Read aloud from this line",
              tabIndex: -1,
              children: O.speak ?? "🔊"
            },
            `sp-${l.starters.join("-")}`
          );
        }),
        /* @__PURE__ */ v(
          "div",
          {
            className: "page-text notranslate" + (M ? " page-text-dialogue" : ""),
            ref: p,
            translate: "no",
            onContextMenu: (l) => l.preventDefault(),
            children: C.map((l, r) => {
              var ee;
              r === C.length - 1 || (H[r + 1], H[r]);
              const f = null, d = y >= 0 && H[r] === y ? " sentence-playing" : "";
              if (!l.w) {
                if (/^\s+$/.test(l.t || "")) {
                  const K = (Oe(C, r - 1, t, W) && Oe(C, r + 1, t, W) ? "word-gap-review" : "") + d;
                  return /* @__PURE__ */ q(fe, { children: [
                    /* @__PURE__ */ v("span", { "data-fi": r, className: K.trim() || void 0, children: De(l.t) }),
                    f
                  ] }, r);
                }
                return /* @__PURE__ */ q(fe, { children: [
                  /* @__PURE__ */ v("span", { "data-fi": r, className: d.trim() || void 0, children: De(l.t) }),
                  f
                ] }, r);
              }
              const u = Ve(r, l, t, W), g = m.get(r) || null;
              let S = "";
              if (u) {
                const Z = G.get(r), te = t && ((ee = t[l.lemma]) == null ? void 0 : ee.translation);
                Z ? N.has(r) && (S = Z) : te && (S = te);
              }
              function R(Z, te) {
                const K = T(r);
                if (g && c) {
                  try {
                    let ce = r;
                    for (; ce > 0 && m.get(ce - 1) === g; ) ce--;
                    let re = r;
                    for (; re < C.length - 1 && m.get(re + 1) === g; ) re++;
                    const ae = p.current;
                    if (ae) {
                      const Re = ae.querySelector(`[data-fi="${ce}"]`), Ne = ae.querySelector(`[data-fi="${re}"]`);
                      if (Re && Ne) {
                        const pe = document.createRange();
                        pe.setStartBefore(Re), pe.setEndAfter(Ne);
                        const me = window.getSelection();
                        me && (me.removeAllRanges(), me.addRange(pe));
                      }
                    }
                  } catch {
                  }
                  c(g, Z, te, K);
                } else
                  i(l, Z, te, K);
              }
              const A = u ? "word word-review" : "word", X = U.has(r) ? " dialogue-speaker" : "";
              return /* @__PURE__ */ q(fe, { children: [
                /* @__PURE__ */ v(
                  "span",
                  {
                    "data-fi": r,
                    className: A + X + d,
                    "data-translation": S || void 0,
                    onClick: (Z) => R(Z.currentTarget.getBoundingClientRect(), Z.currentTarget),
                    children: l.t
                  }
                ),
                f
              ] }, r);
            })
          }
        )
      ]
    }
  );
}
const Bt = /^[,.;:!?…%‰°。，、；：！？)\]}»”’」』】）》〕〗]+$/u;
function Wt(e) {
  return !(e != null && e.w) && /^\s+$/u.test(String((e == null ? void 0 : e.t) || ""));
}
function It(e) {
  if (e != null && e.w) return !1;
  const t = String((e == null ? void 0 : e.t) || "").trim();
  return !!t && Bt.test(t);
}
function Be(e) {
  const t = [];
  for (const n of e || []) {
    const i = { ...n, tokens: [...n.tokens || []] }, c = t[t.length - 1];
    if (c) {
      let a = 0;
      for (; a < i.tokens.length; ) {
        let s = a;
        for (; s < i.tokens.length && Wt(i.tokens[s]); )
          s += 1;
        if (s >= i.tokens.length || !It(i.tokens[s])) break;
        a = s + 1;
      }
      a > 0 && c.tokens.push(...i.tokens.splice(0, a));
    }
    i.tokens.length && t.push(i);
  }
  return t;
}
function Le(e) {
  return String(e || "").toLowerCase().replace(/\s+/g, " ").trim();
}
function We(e) {
  return String(e || "").toLowerCase().replace(/[\s\p{P}\p{S}]+/gu, "");
}
function Ft(e) {
  return !/[\p{L}\p{N}]/u.test(String(e || ""));
}
function Ie(e) {
  return String(e || "").toLowerCase().replace(/^[^\p{L}\p{N}]+|[^\p{L}\p{N}]+$/gu, "");
}
function jt(e, t, n) {
  const i = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Map();
  if (!n || !n.length || !e)
    return { phraseHits: i, phraseAtToken: c };
  const a = [];
  e.forEach((s, o) => {
    s.w && a.push({ flatIdx: t + o, bare: Ie(s.t) });
  });
  for (const s of n) {
    const o = typeof s == "string" ? s : s.surface, h = String(o || "").toLowerCase().split(/\s+/).map((x) => Ie(x)).filter(Boolean);
    if (!(h.length < 2))
      for (let x = 0; x + h.length <= a.length; x++) {
        let _ = !0;
        for (let M = 0; M < h.length; M++)
          if (a[x + M].bare !== h[M]) {
            _ = !1;
            break;
          }
        if (_)
          for (let M = 0; M < h.length; M++) {
            const O = a[x + M].flatIdx;
            i.add(O), typeof s == "object" && !c.has(O) && c.set(O, s);
          }
      }
  }
  return { phraseHits: i, phraseAtToken: c };
}
function Ht(e, t, n) {
  if (!Array.isArray(t) || !t.length) {
    if (n && n.size > 0) {
      const a = [];
      let s = [];
      for (const o of e)
        if (s.push(o), o.w) {
          const h = n.get(Le(o.t)) || "";
          a.push({ pairTgt: h, tokens: s }), s = [];
        }
      return s.length && (a.length ? a[a.length - 1].tokens = a[a.length - 1].tokens.concat(s) : a.push({ pairTgt: "", tokens: s })), Be(a);
    }
    return [{ pairTgt: "", tokens: e }];
  }
  const i = [];
  let c = 0;
  for (const a of t) {
    if (c >= e.length) break;
    const s = We(a.src);
    if (!s) continue;
    let o = "";
    const h = c;
    for (; c < e.length; ) {
      o += e[c].t || "", c += 1;
      const x = We(o);
      if (x.endsWith(s) || x === s || o.length > a.src.length * 3 + 8) break;
    }
    i.push({ pairTgt: a.tgt || "", tokens: e.slice(h, c) });
  }
  return c < e.length && (i.length ? i[i.length - 1].tokens = i[i.length - 1].tokens.concat(e.slice(c)) : i.push({ pairTgt: "", tokens: e.slice(c) })), Be(i);
}
function Yt({
  tok: e,
  flatIdx: t,
  vocabMap: n,
  onWordClick: i,
  onPhraseClick: c,
  sentenceText: a,
  wordGloss: s,
  phraseHits: o,
  phraseAtToken: h
}) {
  const x = n == null ? void 0 : n[e.lemma], _ = o == null ? void 0 : o.has(t), M = (x == null ? void 0 : x.status) === "learning", O = _ || M, p = (s == null ? void 0 : s.get(Le(e.t))) || "";
  return /* @__PURE__ */ v(
    "span",
    {
      "data-fi": t,
      className: "word" + (O ? " word-review" : ""),
      "data-translation": p || void 0,
      onClick: (b) => {
        const F = b.currentTarget.getBoundingClientRect();
        if (_ && c) {
          const Y = h == null ? void 0 : h.get(t);
          if (Y) {
            c(Y, F, b.currentTarget, a);
            return;
          }
        }
        i && i(e, F, b.currentTarget, a);
      },
      children: e.t
    }
  );
}
function zt({
  sentence: e,
  si: t,
  vocabMap: n,
  savedPhrases: i,
  onWordClick: c,
  onPhraseClick: a,
  startFlatIdx: s,
  speakingSentence: o,
  pairs: h,
  words: x
}) {
  const { phraseHits: _, phraseAtToken: M } = ne(
    () => jt(e, s, i),
    [e, s, i]
  ), O = ne(() => oe.text(e), [e]), p = ne(() => {
    const C = /* @__PURE__ */ new Map();
    return (x || []).forEach((k) => {
      k != null && k.src && C.set(Le(k.src), k.tgt || "");
    }), C;
  }, [x]), b = ne(
    () => Ht(e, h || [], p),
    [e, h, p]
  ), F = !!o && o === O, Y = V(null), [B, I] = z(() => /* @__PURE__ */ new Set());
  he(() => {
    const C = Y.current;
    if (!C) return;
    let k = 0;
    const H = () => {
      const j = C.querySelectorAll(".chunk-cell"), U = /* @__PURE__ */ new Set();
      for (let W = 0; W < j.length - 1; W++)
        Math.abs(j[W].offsetTop - j[W + 1].offsetTop) > 2 && U.add(W);
      I((W) => W.size === U.size && [...W].every((G) => U.has(G)) ? W : U);
    };
    k = requestAnimationFrame(H);
    const T = () => {
      k = requestAnimationFrame(H);
    };
    return window.addEventListener("resize", T), () => {
      window.removeEventListener("resize", T), k && cancelAnimationFrame(k);
    };
  }, [b]);
  let $ = s;
  return /* @__PURE__ */ v(
    "span",
    {
      className: "chunked-sent" + (F ? " chunked-sent-playing" : ""),
      "data-si": t,
      children: /* @__PURE__ */ v("span", { className: "chunked-sent-flow", ref: Y, children: b.map((C, k) => {
        const H = C.pairTgt && !Ft(C.pairTgt), T = k === b.length - 1, j = B.has(k);
        return /* @__PURE__ */ q("span", { className: "chunk-cell", children: [
          /* @__PURE__ */ v("span", { className: "chunk-cell-gloss", children: H ? C.pairTgt : " " }),
          /* @__PURE__ */ q("span", { className: "chunk-cell-src", children: [
            C.tokens.map((U, W) => {
              const G = $;
              return $ += 1, U.w ? /* @__PURE__ */ v(
                Yt,
                {
                  tok: U,
                  flatIdx: G,
                  vocabMap: n,
                  onWordClick: c,
                  onPhraseClick: a,
                  sentenceText: O,
                  wordGloss: p,
                  phraseHits: _,
                  phraseAtToken: M
                },
                W
              ) : /* @__PURE__ */ v(fe, { children: U.t }, W);
            }),
            !T && /* @__PURE__ */ v(
              "span",
              {
                className: "chunk-sep" + (j ? " chunk-sep-hidden" : ""),
                "aria-hidden": "true",
                children: "•"
              }
            )
          ] })
        ] }, k);
      }) })
    }
  );
}
function qt({
  tokens: e,
  sourceLang: t,
  targetLang: n,
  vocabMap: i,
  savedPhrases: c,
  onWordClick: a,
  onPhraseClick: s,
  onPlaySentence: o,
  speakingSentence: h,
  audioOnClick: x,
  onPlayWord: _,
  // Pre-fetched batch (Map<sentenceText, {pairs, words}>) supplied
  // by Reader when chunked mode is on AND page generation bundles
  // the chunked translations under the same loading bar. When
  // present, skip the local fetch + the local "ready — read"
  // hand-off (Reader already did both). Falls back to the
  // self-fetch path when null (e.g. the reader toggled chunked
  // ON mid-page, where Reader hasn't prefetched).
  prefetched: M
}) {
  const O = Ce(), p = ne(() => oe.sentences(e), [e]), b = ne(
    () => p.map((L) => oe.text(L)),
    [p]
  ), F = ne(
    () => `${t}::${n}::${b.join("|")}`,
    [t, n, b]
  ), [Y, B] = z({ key: "", status: "idle", byText: /* @__PURE__ */ new Map() });
  Q(() => {
    if (M && M.size > 0) {
      B({ key: F, status: "ready", byText: M });
      return;
    }
    let L = !1;
    const w = b.filter(Boolean);
    if (!w.length) {
      B({ key: F, status: "ready", byText: /* @__PURE__ */ new Map() });
      return;
    }
    return B({ key: F, status: "loading", byText: /* @__PURE__ */ new Map() }), Promise.all(
      w.map((E) => qe(E, t, n))
    ).then((E) => {
      if (L) return;
      const l = /* @__PURE__ */ new Map();
      for (const r of E) l.set(r.text, { pairs: r.pairs, words: r.words });
      B({ key: F, status: "ready", byText: l });
    }), () => {
      L = !0;
    };
  }, [F, t, n, b, M]);
  let I = 0;
  const C = Y.status === "ready" && Y.key === F, k = typeof o == "function", H = V(null), [T, j] = z([]), [U, W] = z(-1), G = V(null);
  Q(() => {
    G.current = null, W(-1);
  }, [F]), he(() => {
    var u;
    if (!C || !k) {
      j((g) => g.length ? [] : g);
      return;
    }
    const L = H.current;
    if (!L) return;
    let w = 0, E = !1;
    const l = () => {
      if (E) return;
      const g = L.getBoundingClientRect(), S = [];
      p.forEach((R, A) => {
        const X = L.querySelector(`[data-si="${A}"]`), ee = (X == null ? void 0 : X.querySelector("[data-fi]")) || (X == null ? void 0 : X.querySelector(".chunk-cell-src"));
        if (!ee) return;
        const Z = ee.getBoundingClientRect(), te = Z.top - g.top, K = S[S.length - 1];
        K && Math.abs(K.top - te) <= 4 ? (K.starters.push(A), K.height = Math.max(K.height, Z.height)) : S.push({ top: te, height: Z.height, starters: [A] });
      }), j((R) => R.length === S.length && R.every((X, ee) => {
        const Z = S[ee];
        return Math.abs(X.top - Z.top) < 1 && Math.abs(X.height - Z.height) < 1 && X.starters.join(",") === Z.starters.join(",");
      }) ? R : S);
    }, r = () => {
      w && cancelAnimationFrame(w), w = requestAnimationFrame(l);
    };
    r(), window.addEventListener("resize", r);
    const f = L.querySelector(".chunked-view"), d = typeof ResizeObserver == "function" && f ? new ResizeObserver(r) : null;
    return d && d.observe(f), (u = document.fonts) != null && u.ready && document.fonts.ready.then(() => {
      E || r();
    }), () => {
      E = !0, window.removeEventListener("resize", r), d && d.disconnect(), w && cancelAnimationFrame(w);
    };
  }, [C, k, p, Y.byText]);
  function m(L) {
    const w = H.current;
    if (!w) return -1;
    const E = L - w.getBoundingClientRect().top;
    for (let l = 0; l < T.length; l += 1) {
      const r = T[l];
      if (E >= r.top - 3 && E <= r.top + r.height + 3) return l;
    }
    return -1;
  }
  function N(L) {
    k && W(m(L.clientY));
  }
  function y(L) {
    var S, R;
    if (!k) return;
    let w = L.target;
    for (; w && w !== H.current; ) {
      if (((S = w == null ? void 0 : w.dataset) == null ? void 0 : S.fi) != null || (R = w == null ? void 0 : w.classList) != null && R.contains("line-speak")) return;
      w = w.parentNode;
    }
    const E = H.current, l = E == null ? void 0 : E.querySelector(".chunked-view");
    if (!E || !l) return;
    const r = l.getBoundingClientRect();
    if (L.clientX >= r.left || L.clientY < r.top || L.clientY > r.bottom) return;
    const f = m(L.clientY);
    if (f < 0) return;
    const d = T[f], u = E.getBoundingClientRect(), g = {
      left: r.left,
      top: u.top + d.top,
      right: r.left + 1,
      bottom: u.top + d.top + d.height,
      width: 1,
      height: d.height,
      x: r.left,
      y: u.top + d.top
    };
    P(f, g);
  }
  function P(L, w) {
    const E = T[L];
    if (!E || !o) return;
    const l = Ge(G.current, E.starters);
    if (l.sentenceIndex < 0) return;
    G.current = l.state;
    const r = b[l.sentenceIndex];
    r && o(r, w);
  }
  const D = h ? b.findIndex((L) => L === h) : -1;
  return /* @__PURE__ */ q(
    "div",
    {
      className: "chunked-view-wrap",
      ref: H,
      onMouseMove: N,
      onMouseLeave: () => W(-1),
      onClick: y,
      children: [
        C && k && T.map((L, w) => {
          const E = L.starters.includes(D);
          return !(U === w) && !E ? null : /* @__PURE__ */ v(
            "button",
            {
              type: "button",
              className: "line-speak" + (E ? " line-speak-loading" : ""),
              style: { top: `${L.top + L.height / 2}px` },
              onClick: (r) => P(
                w,
                r.currentTarget.getBoundingClientRect()
              ),
              title: "Read aloud from this line",
              "aria-label": "Read aloud from this line",
              tabIndex: -1,
              children: O.speak ?? "🔊"
            },
            `chunk-sp-${L.starters.join("-")}`
          );
        }),
        /* @__PURE__ */ q(
          "div",
          {
            className: "chunked-view notranslate",
            translate: "no",
            onContextMenu: (L) => L.preventDefault(),
            children: [
              !C && // Mid-page mode toggle (normal → chunked) hits this
              // fallback path; the wait is usually short, and the
              // matching game would be a heavy placeholder. The
              // page-generation flow already shows the game (driven
              // by Reader with bundled prefetch — that path skips
              // this block entirely because `prefetched` arrives
              // already-ready).
              /* @__PURE__ */ v("div", { className: "chunked-view-loading", children: "preparing chunked translation…" }),
              C && p.map((L, w) => {
                const E = I;
                I += L.length;
                const l = b[w], r = Y.byText.get(l) || { pairs: null, words: [] };
                return /* @__PURE__ */ v(
                  zt,
                  {
                    si: w,
                    sentence: L,
                    startFlatIdx: E,
                    vocabMap: i,
                    savedPhrases: c,
                    onWordClick: a,
                    onPhraseClick: s,
                    speakingSentence: h,
                    pairs: r.pairs,
                    words: r.words
                  },
                  w
                );
              })
            ]
          }
        )
      ]
    }
  );
}
let Gt = class extends nt {
  constructor(n) {
    super(n);
    ge(this, "reset", () => {
      this.setState({ error: null });
    });
    this.state = { error: null };
  }
  static getDerivedStateFromError(n) {
    return { error: n };
  }
  componentDidCatch(n, i) {
    if (console.error("[ErrorBoundary] caught:", n, i), this.props.reportTo)
      try {
        const c = {
          message: String((n == null ? void 0 : n.message) || n || "unknown"),
          stack: String((n == null ? void 0 : n.stack) || ""),
          componentStack: String((i == null ? void 0 : i.componentStack) || ""),
          url: typeof window < "u" ? window.location.href : "",
          userAgent: typeof navigator < "u" ? navigator.userAgent : ""
        };
        fetch(this.props.reportTo, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(c)
        }).catch(() => {
        });
      } catch {
      }
  }
  componentDidUpdate(n, i) {
    this.state.error && !i.error && this.props.autoRecoverMs && (this.recoverTimer && clearTimeout(this.recoverTimer), this.recoverTimer = setTimeout(() => {
      this.recoverTimer = null, this.reset();
    }, this.props.autoRecoverMs));
  }
  componentWillUnmount() {
    this.recoverTimer && clearTimeout(this.recoverTimer);
  }
  render() {
    return this.state.error ? typeof this.props.fallback == "function" ? this.props.fallback(this.state.error, this.reset) : this.props.fallback !== void 0 ? this.props.fallback : null : this.props.children;
  }
};
const Ut = Dt, Vt = qt, Kt = Gt;
function Xt(e) {
  const {
    book: t,
    chunked: n,
    onTranslateSentence: i = null,
    sentenceTranslations: c = {},
    onPlayWord: a = null,
    prefetched: s = null,
    ...o
  } = e, h = /* @__PURE__ */ v(
    Ut,
    {
      ...o,
      onTranslateSentence: i,
      sentenceTranslations: c,
      showTranslateIcon: !!t.translate_with_voiceover,
      dialogue: t.mode === "dialogue"
    }
  );
  return n ? /* @__PURE__ */ v(
    Kt,
    {
      fallback: (x) => /* @__PURE__ */ q(ie, { children: [
        /* @__PURE__ */ q("div", { className: "chunked-view-loading", style: { color: "#b94a48" }, children: [
          "Chunked view failed — showing regular text. (",
          String((x == null ? void 0 : x.message) || x || "unknown error"),
          ")"
        ] }),
        h
      ] }),
      children: /* @__PURE__ */ v(
        Vt,
        {
          ...o,
          sourceLang: t.target_lang,
          targetLang: t.native_lang,
          onPlayWord: a,
          prefetched: s
        }
      )
    }
  ) : h;
}
function Ke({
  word: e,
  rect: t,
  translation: n,
  monolingual: i,
  status: c,
  canMarkLearned: a,
  busy: s,
  autoPlay: o,
  onSpeak: h,
  onMarkLearned: x,
  onClose: _,
  canSave: M,
  onSave: O,
  saving: p,
  onUnsave: b,
  onRelearn: F,
  definitionOnly: Y,
  mobile: B
}) {
  const I = V(null), $ = Ce(), C = V(null);
  C.current === null && (C.current = {
    canSave: !!M,
    canMarkLearned: !!a,
    status: c || null,
    hasUnsave: typeof b == "function",
    hasRelearn: typeof F == "function"
  });
  const k = C.current, H = k.canSave, T = k.canMarkLearned, j = k.status, U = k.hasUnsave, W = k.hasRelearn, [G, m] = z(null), [N, y] = z(0), P = V({ startY: 0, dragging: !1 });
  Q(() => {
    function l(r) {
      r.key === "Escape" && _();
    }
    return document.addEventListener("keydown", l), () => document.removeEventListener("keydown", l);
  }, [_]), Q(() => {
    o && h();
  }, []), he(() => {
    if (B) {
      m(null);
      return;
    }
    const l = I.current;
    if (!t || !l) return;
    const { width: r, height: f } = l.getBoundingClientRect(), d = window.innerWidth, u = window.innerHeight, g = 10, S = 8;
    let R = Math.min(t.left, d - r - g);
    R = Math.max(R, g);
    let A;
    t.bottom + S + f <= u - g ? A = t.bottom + S : t.top - S - f >= g ? A = t.top - S - f : A = Math.max(g, u - f - g), m({ top: A, left: R });
  }, [t, e, n, c, s, a, B]);
  function D(l) {
    if (B) {
      P.current = { startY: l.clientY, dragging: !0 };
      try {
        l.currentTarget.setPointerCapture(l.pointerId);
      } catch {
      }
    }
  }
  function L(l) {
    if (!B || !P.current.dragging) return;
    const r = Math.max(0, l.clientY - P.current.startY);
    y(r);
  }
  function w() {
    if (!B || !P.current.dragging) return;
    const l = N;
    P.current.dragging = !1, l > 80 ? _() : y(0);
  }
  if (!t) return null;
  const E = B ? N ? { transform: `translateY(${N}px)`, transition: "none" } : {} : G ? { top: G.top, left: G.left } : { top: t.bottom + 8, left: t.left, visibility: "hidden" };
  return /* @__PURE__ */ q(ie, { children: [
    B && /* @__PURE__ */ v("div", { className: "popup-backdrop popup-backdrop-mobile", onClick: _ }),
    /* @__PURE__ */ q(
      "div",
      {
        className: "word-popup" + (B ? " word-popup-mobile" : ""),
        ref: I,
        style: E,
        onPointerDown: B ? D : void 0,
        onPointerMove: B ? L : void 0,
        onPointerUp: B ? w : void 0,
        onPointerCancel: B ? w : void 0,
        children: [
          B && /* @__PURE__ */ v("div", { className: "word-popup-grabber", "aria-hidden": "true" }),
          /* @__PURE__ */ q("div", { className: "word-popup-head", children: [
            /* @__PURE__ */ q("span", { className: "word-popup-word", children: [
              /* @__PURE__ */ v(
                "button",
                {
                  type: "button",
                  className: "word-popup-speak",
                  onClick: h,
                  "aria-label": "Hear it",
                  title: "Hear it",
                  children: /* @__PURE__ */ v("span", { "aria-hidden": "true", children: $.speak ?? "🔊" })
                }
              ),
              e
            ] }),
            /* @__PURE__ */ v("button", { className: "word-popup-close", onClick: _, "aria-label": "Close", children: $.close ?? "×" })
          ] }),
          /* @__PURE__ */ v("div", { className: "word-popup-translation", children: n || (s ? i ? "Defining…" : "Translating…" : "—") }),
          Y ? (
            /* Read-only popup. Used in the native-language translation
               column — the reader doesn't need to save a word that's
               already in their language, just to see what it means. */
            null
          ) : H ? (
            // Multi-word phrase selection — explicit Save button so nothing
            // lands in the vocab list until the reader asks for it.
            /* @__PURE__ */ v("div", { className: "word-popup-actions", children: /* @__PURE__ */ v("button", { className: "btn-primary small", disabled: s || p || !n, onClick: O, children: p ? "Saving…" : "+ Save" }) })
          ) : j === "learned" ? (
            // Word is already learned. Acknowledge it AND offer a way back —
            // tapping Save moves it from `learned` back to `learning`, so it
            // re-highlights on the page and shows up in the To-learn tab again.
            /* @__PURE__ */ q("div", { className: "word-popup-row", children: [
              /* @__PURE__ */ v("span", { className: "word-popup-status done", children: "✓ Learned" }),
              W && F && /* @__PURE__ */ v(
                "button",
                {
                  type: "button",
                  className: "btn-primary small",
                  disabled: s,
                  onClick: F,
                  children: "Save"
                }
              )
            ] })
          ) : (
            // Single-word: auto-saved on tap. Offer Mark-learned for words
            // that already had an entry before this click, and always show a
            // small "un-save" link in case the save was a misclick.
            /* @__PURE__ */ q("div", { className: "word-popup-row", children: [
              T && /* @__PURE__ */ v("button", { className: "btn-primary small", disabled: s, onClick: x, children: "Mark as learned" }),
              !T && /* @__PURE__ */ v("span", { className: "word-popup-status", children: "Saved to your words" }),
              U && b && !T && // Only the INITIAL save (auto-saved by the very tap that
              // opened the popup) shows the un-save link, labelled
              // "do not save" — the natural undo for the tap. A re-click
              // of a previously-saved word shows "Mark as learned"
              // alone; the reader can manage the entry from the Words
              // tab if they want to drop it.
              /* @__PURE__ */ v("button", { type: "button", className: "word-popup-unsave", onClick: b, children: "do not save" })
            ] })
          )
        ]
      }
    )
  ] });
}
const Jt = Ke;
function Qt(e) {
  const { wordPopup: { popup: t, view: n, dismiss: i }, monolingual: c, mobile: a, autoPlay: s, speakWord: o, markLearned: h, relearn: x, removeVocab: _ } = e;
  if (!t || !n) return null;
  const { lemma: M, action: O } = n;
  return /* @__PURE__ */ v(
    Jt,
    {
      mobile: a,
      word: t.token.t,
      rect: t.rect,
      translation: n.translation,
      monolingual: c,
      status: n.initialStatus,
      canMarkLearned: n.canMarkLearned,
      busy: n.busy,
      autoPlay: s,
      definitionOnly: !!t.definitionOnly,
      onSpeak: () => o(t.token.t),
      onMarkLearned: () => {
        h(M), i();
      },
      onRelearn: O === "learnedRelearn" && M ? () => {
        x(M), i();
      } : void 0,
      onUnsave: O === "fresh" && M ? () => {
        try {
          _(M);
        } catch {
        }
        i();
      } : void 0,
      onClose: i
    },
    t.id
  );
}
const Zt = {
  A1: "#5a9e6f",
  A2: "#5a9e6f",
  B1: "#c79435",
  B2: "#c79435",
  C1: "#b5603f",
  C2: "#b5603f"
};
function en({ level: e, onClick: t, auto: n }) {
  const i = /* @__PURE__ */ v(
    "span",
    {
      className: t ? "cefr-badge cefr-badge-click" : "cefr-badge",
      style: { background: Zt[e] || "#888" },
      onClick: t,
      role: t ? "button" : void 0,
      children: e
    }
  );
  return n ? /* @__PURE__ */ q("span", { className: "cefr-badge-wrap", children: [
    i,
    /* @__PURE__ */ v("span", { className: "cefr-badge-auto", children: "auto" })
  ] }) : i;
}
const tn = Ke, Fe = { id: null, canSave: !1, canMarkLearned: !1, canRelearn: !1, status: null };
function nn({ selection: e, mobile: t, autoPlay: n, speakWord: i, markLearned: c, relearn: a }) {
  var Y;
  const { selAction: s, selPopup: o, startHandleDrag: h, onHandleEnter: x, onHandleLeave: _, dismissPhrase: M, saveSelectedPhrase: O } = e, p = V(Fe);
  o && p.current.id !== o.id ? p.current = {
    id: o.id,
    canSave: !o.definitionOnly && !o.saved && (((Y = o.text) == null ? void 0 : Y.length) ?? 0) <= 120,
    canMarkLearned: !o.definitionOnly && !!o.saved && o.status === "learning" && !!o.lemma,
    canRelearn: !!o.saved && o.status === "learned" && !!o.lemma,
    status: o.status || null
  } : !o && p.current.id !== null && (p.current = Fe);
  const b = p.current, F = (B, I, $) => /* @__PURE__ */ v(
    "div",
    {
      className: `sel-handle sel-handle-${B}`,
      style: { top: I, left: $ },
      onPointerDown: (C) => h(B, C),
      onPointerEnter: x,
      onPointerLeave: _,
      onMouseDown: (C) => C.preventDefault(),
      onClick: (C) => {
        C.preventDefault(), C.stopPropagation();
      },
      "aria-label": `Drag to extend selection ${B}`
    }
  );
  return /* @__PURE__ */ q(ie, { children: [
    (s == null ? void 0 : s.startRect) && F("start", s.startRect.bottom + 4, s.startRect.left - 8),
    (s == null ? void 0 : s.endRect) && F("end", s.endRect.bottom + 4, s.endRect.right + 8),
    o && /* @__PURE__ */ v(
      tn,
      {
        mobile: t,
        word: o.text,
        rect: o.rect,
        translation: o.translation,
        monolingual: !!o.definitionOnly,
        status: b.status,
        canMarkLearned: b.canMarkLearned,
        busy: !!o.busy,
        autoPlay: n && !o.busy,
        definitionOnly: !!o.definitionOnly,
        onSpeak: () => i(o.text, o.lang),
        canSave: b.canSave,
        saving: !!o.saving,
        onSave: O,
        onMarkLearned: () => {
          o.lemma && c && c(o.lemma), M();
        },
        onRelearn: b.canRelearn && a ? () => {
          a(o.lemma), M();
        } : void 0,
        onClose: M
      },
      o.id + (o.busy ? ":busy" : ":done")
    )
  ] });
}
function Se(e) {
  const t = [...e];
  for (let n = t.length - 1; n > 0; n--) {
    const i = Math.floor(Math.random() * (n + 1));
    [t[n], t[i]] = [t[i], t[n]];
  }
  return t;
}
function rn({ words: e, audioOnClick: t, onPlay: n }) {
  const [i, c] = z(0), [a, s] = z({}), [o, h] = z(null), [x, _] = z(null), [M, O] = z(0), p = ne(() => Se(e), [e]), b = Math.ceil(p.length / 6), F = Math.min(i, Math.max(0, b - 1)), Y = F + 1 < b, B = ne(() => {
    if (!p.length) return [];
    const T = Math.floor(F * p.length / b), j = Math.floor((F + 1) * p.length / b);
    return Se(p.slice(T, j));
  }, [p, F, b]), I = ne(
    () => Se(B.map((T, j) => ({ text: T.meaning, pair: j }))),
    [B]
  ), $ = B.length > 0 && Object.keys(a).length === B.length;
  function C(T, j) {
    h(T), t && n && j && n(j);
  }
  function k(T) {
    o === null || a[o] || (T === o ? (s((j) => ({ ...j, [o]: !0 })), h(null), O((j) => j + 1)) : (_(T), setTimeout(() => _(null), 400), h(null)));
  }
  function H() {
    s({}), h(null), _(null), c(F + 1);
  }
  return /* @__PURE__ */ q("div", { className: "match-game", children: [
    /* @__PURE__ */ q("div", { className: "match-game-bar", children: [
      /* @__PURE__ */ v("span", { children: "Warm up — match the words you know" }),
      /* @__PURE__ */ q("span", { className: "match-game-score", children: [
        M,
        " matched"
      ] })
    ] }),
    /* @__PURE__ */ q("div", { className: "match-grid", children: [
      /* @__PURE__ */ v("div", { className: "match-col", children: B.map((T, j) => /* @__PURE__ */ v(
        "button",
        {
          disabled: !!a[j],
          className: "match-item" + (a[j] ? " matched" : "") + (o === j ? " selected" : ""),
          onClick: () => C(j, T.word),
          children: T.word
        },
        j
      )) }),
      /* @__PURE__ */ v("div", { className: "match-col", children: I.map((T, j) => /* @__PURE__ */ v(
        "button",
        {
          disabled: !!a[T.pair],
          className: "match-item" + (a[T.pair] ? " matched" : "") + (x === T.pair ? " flash-wrong" : ""),
          onClick: () => k(T.pair),
          children: T.text
        },
        j
      )) })
    ] }),
    $ && /* @__PURE__ */ q("div", { className: "match-game-done", children: [
      /* @__PURE__ */ v("span", { children: "All matched — nicely done! 🎉" }),
      Y && /* @__PURE__ */ v("button", { className: "btn-ghost", onClick: H, children: "New words →" })
    ] })
  ] });
}
const je = ["/", "-", "\\", "|"];
function an({ intervalMs: e = 120 }) {
  const [t, n] = z(0);
  return Q(() => {
    const i = setInterval(() => n((c) => (c + 1) % je.length), e);
    return () => clearInterval(i);
  }, [e]), /* @__PURE__ */ v("span", { className: "ascii-spin", "aria-hidden": "true", children: je[t] });
}
const on = rn, Xe = an;
function Je({ label: e }) {
  return /* @__PURE__ */ v("div", { className: "page-sheet page-loading", children: /* @__PURE__ */ q("div", { className: "brew-line", children: [
    e,
    " ",
    /* @__PURE__ */ v(Xe, {})
  ] }) });
}
function sn({ done: e, brewingLabel: t, readyLabel: n, readyAction: i, onReady: c, words: a, audioOnClick: s, onPlay: o }) {
  return /* @__PURE__ */ q("div", { className: "loading-game", children: [
    /* @__PURE__ */ v("div", { className: "loading-game-head" + (e ? " done" : ""), children: e ? /* @__PURE__ */ q(ie, { children: [
      /* @__PURE__ */ v("span", { children: n }),
      /* @__PURE__ */ q("button", { type: "button", className: "btn-primary brew-ready-btn", onClick: c, children: [
        i,
        /* @__PURE__ */ v("svg", { className: "brew-ready-chevron", viewBox: "0 0 16 16", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", children: /* @__PURE__ */ v("path", { d: "M6 3.5 10.5 8 6 12.5" }) })
      ] })
    ] }) : /* @__PURE__ */ q(ie, { children: [
      t,
      " ",
      /* @__PURE__ */ v(Xe, {})
    ] }) }),
    a && a.length >= 2 ? /* @__PURE__ */ v(on, { words: a, audioOnClick: s, onPlay: o }) : !e && /* @__PURE__ */ v(Je, { label: t })
  ] });
}
function cn({ game: e, generating: t, audioOnClick: n, onPlay: i, footer: c, children: a }) {
  return e.loadingGame ? /* @__PURE__ */ v(
    sn,
    {
      done: e.genDone,
      brewingLabel: "Your next page is brewing",
      readyLabel: "Your next page is ready",
      readyAction: "Read",
      onReady: e.proceed,
      words: e.gameSnapshot,
      audioOnClick: n,
      onPlay: i
    }
  ) : /* @__PURE__ */ q(ie, { children: [
    t ? /* @__PURE__ */ v(Je, { label: "Your next page is brewing" }) : a,
    c
  ] });
}
function ln({ children: e }) {
  return /* @__PURE__ */ q("div", { className: "end-card", children: [
    /* @__PURE__ */ v("h3", { children: "The End" }),
    /* @__PURE__ */ v("p", { children: "You reached C2 and finished this book. Beautifully done." }),
    e
  ] });
}
const un = en, He = `This book adapts as you read.
	After each page, if you tapped only a few words it nudges the difficulty up;
	if you tapped a lot, it eases off — so it settles at the level that fits you, all the way to C2.`, dn = {}, Ye = "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Lora:ital,wght@0,400;0,500;0,600;1,400&display=swap", ze = "(max-width: 720px)";
function fn() {
  Q(() => {
    if (document.querySelector(`link[href="${Ye}"]`)) return;
    const e = document.createElement("link");
    e.rel = "stylesheet", e.href = Ye, document.head.appendChild(e);
  }, []);
}
function gn() {
  const [e, t] = z(() => window.matchMedia(ze).matches);
  return Q(() => {
    const n = window.matchMedia(ze), i = () => t(n.matches);
    return n.addEventListener("change", i), () => n.removeEventListener("change", i);
  }, []), e;
}
function hn() {
  const [e, t] = z(null);
  return Q(() => {
    const n = document.createElement("div");
    return n.className = "eb-embed", document.body.appendChild(n), t(n), () => {
      n.remove();
    };
  }, []), e;
}
function bn({ bookId: e, apiBase: t, getToken: n, topSlot: i, onOpenSettings: c, icons: a, tooltip: s, onBook: o, onError: h }) {
  ct({ apiBase: t, getToken: n, adsConsent: () => "denied" }), fn();
  const x = gn(), _ = hn(), M = V(null), O = ut(e, {
    scrollTop: () => {
      var S;
      return (S = M.current) == null ? void 0 : S.scrollTo({ top: 0, behavior: "smooth" });
    }
  }), { book: p, page: b, vocabMap: F, loading: Y, error: B, errorStatus: I, actionError: $, generating: C } = O, { audioOnClick: k, setAudioOnClick: H, chunkedOn: T, setChunkedOn: j } = bt(), { speakingSentence: U, speakWord: W, stopSpeaking: G } = mt(p == null ? void 0 : p.id, b == null ? void 0 : b.page_number), m = Tt(p, b, T), N = Ot({ generating: C, actionError: $, vocabMap: F, page: b, isChunkedReady: m.isReadyFor }), y = pt({
    book: p,
    page: b,
    vocabMap: F,
    applyVocab: O.applyVocab,
    removeVocab: O.removeVocab,
    closeWordPopup: () => P.closePopup(),
    stopSpeaking: G
  }), P = ft({
    book: p,
    page: b,
    vocabMap: F,
    clickWord: O.clickWord,
    hasOtherPopup: !!y.selPopup,
    onCloseOthers: y.closePhrasePopup,
    onDismiss: () => {
      y.clearSelection(), G();
    },
    shouldIgnoreClick: y.justDragged,
    // a just-saved word is dropped if the reader extends it into a saved phrase
    onOpened: (S, R) => y.setOriginLemma(S === "fresh" ? R : null)
  }), { onPrev: D, onNext: L, swipeHandlers: w } = yt({
    book: p,
    page: b,
    goToPage: O.goToPage,
    nextPage: O.nextPage,
    beforeTurn: G
  });
  if (Q(() => {
    p && (o == null || o(p));
  }, [p]), Q(() => {
    B && (h == null || h({ message: B, status: I }));
  }, [B, I]), Y)
    return /* @__PURE__ */ v("div", { className: "eb-embed", children: /* @__PURE__ */ v("div", { className: "centered-msg", children: "Opening your book…" }) });
  if (B || !p || !b)
    return /* @__PURE__ */ v("div", { className: "eb-embed", children: /* @__PURE__ */ v("div", { className: "centered-msg error", children: B || "Book not found" }) });
  const E = oe.scenes(b), l = b.page_number >= p.page_count, r = p.mine && p.status !== "completed" && !p.practice, f = p.status === "completed" && l, d = p.target_lang === p.native_lang, u = (S, R, A) => s ? s(S, R) : rt(R, { title: A ?? String(S) }), g = `Reading level ${p.cefr_level} · ${p.level_locked ? "fixed" : "auto-adjusting"}`;
  return /* @__PURE__ */ v(Ue.Provider, { value: a || dn, children: /* @__PURE__ */ q("div", { className: "eb-embed eb-reader", ref: M, children: [
    /* @__PURE__ */ q("div", { className: "reader", children: [
      /* @__PURE__ */ v("div", { className: "reader-head", children: /* @__PURE__ */ q("div", { className: "reader-meta", children: [
        u(
          // one block: a host tooltip laid out as a row can't split heading and text
          /* @__PURE__ */ q("div", { children: [
            /* @__PURE__ */ v("b", { children: g }),
            /* @__PURE__ */ v("div", { style: { marginTop: 4 }, children: He })
          ] }),
          /* @__PURE__ */ v("span", { className: "eb-level", children: /* @__PURE__ */ v(un, { level: p.cefr_level }) }),
          `${g}. ${He}`
        ),
        /* @__PURE__ */ v("span", { children: "·" }),
        u(k ? "Auto-voice on — clicking a word also plays its audio" : "Auto-voice off — popups are silent", /* @__PURE__ */ v(
          "button",
          {
            className: "reader-icon-btn reader-mode-switch" + (k ? " is-on" : ""),
            onClick: () => H(!k),
            "aria-pressed": k,
            children: (a == null ? void 0 : a.audio) ?? "🔊"
          }
        )),
        u(T ? "Chunked translation on — tap to turn off" : "Chunked translation off — tap to turn on", /* @__PURE__ */ v(
          "button",
          {
            className: "reader-icon-btn reader-mode-switch" + (T ? " is-on" : ""),
            onClick: () => j(!T),
            "aria-pressed": T,
            children: (a == null ? void 0 : a.translate) ?? "文A"
          }
        )),
        c && b.page_number !== 1 && u("Book settings", /* @__PURE__ */ v("button", { className: "reader-icon-btn", onClick: c, "aria-label": "Book settings", children: (a == null ? void 0 : a.settings) ?? "⚙" }))
      ] }) }),
      b.page_number === 1 && i,
      $ && /* @__PURE__ */ v("div", { className: "banner error", children: $ }),
      /* @__PURE__ */ v(
        cn,
        {
          game: N,
          generating: C,
          audioOnClick: k,
          onPlay: W,
          footer: /* @__PURE__ */ q(ie, { children: [
            f && /* @__PURE__ */ v(ln, {}),
            /* @__PURE__ */ v("div", { className: "reader-foot", children: /* @__PURE__ */ q("div", { className: "reader-nav reader-nav-compact", children: [
              u("Previous page", /* @__PURE__ */ v(
                "button",
                {
                  className: "reader-icon-btn",
                  disabled: N.busy || b.page_number <= 1,
                  onClick: D,
                  "aria-label": "Previous page",
                  children: (a == null ? void 0 : a.prev) ?? "«"
                }
              )),
              /* @__PURE__ */ q("span", { className: "reader-page-num", children: [
                b.page_number,
                " / ",
                p.page_count
              ] }),
              u(f ? "The book is finished" : l ? "Write the next page" : "Next page", /* @__PURE__ */ v(
                "button",
                {
                  className: "reader-icon-btn",
                  disabled: N.busy || l && !r,
                  onClick: L,
                  "aria-label": "Next page",
                  children: (a == null ? void 0 : a.next) ?? "»"
                }
              ))
            ] }) })
          ] }),
          children: /* @__PURE__ */ v("article", { className: "page-sheet", ...w, children: E.map((S, R) => /* @__PURE__ */ v("div", { className: "scene-row", children: /* @__PURE__ */ v("div", { className: "scene", children: /* @__PURE__ */ v(
            Xt,
            {
              book: p,
              tokens: S.tokens,
              chunked: T,
              vocabMap: F,
              savedPhrases: y.savedPhrases,
              onWordClick: P.onWordClick,
              onPhraseClick: y.onPhraseClick,
              onPlaySentence: (A) => W(A),
              speakingSentence: U,
              audioOnClick: k,
              onPlayWord: W,
              prefetched: m.prefetched
            }
          ) }) }, R)) })
        }
      )
    ] }),
    _ && ot(
      /* @__PURE__ */ q(ie, { children: [
        /* @__PURE__ */ v(
          Qt,
          {
            wordPopup: P,
            monolingual: d,
            mobile: x,
            autoPlay: k,
            speakWord: W,
            markLearned: O.markLearned,
            relearn: O.relearn,
            removeVocab: O.removeVocab
          }
        ),
        /* @__PURE__ */ v(
          nn,
          {
            selection: y,
            mobile: x,
            autoPlay: k,
            speakWord: W,
            markLearned: O.markLearned,
            relearn: O.relearn
          }
        )
      ] }),
      _
    )
  ] }) });
}
export {
  bn as BookReader
};
